import Track, { OnePayEventNames } from 'modules/tracking';

/**
 * Creates a script and injects it into the DOM body.
 * @param url
 * @param {number} [maxWait=3000] - How long to wait for the promise to resolve (in milliseconds) before rejecting.
 * @returns {Promise}
 */
export const createScript = (url: string, srcIntegrity = '', crossOrigin = '', maxWait = 5000): Promise<void> =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${url}?t=${new Date().getTime()}`;
    if (srcIntegrity) script.integrity = srcIntegrity;
    if (crossOrigin) script.crossOrigin = crossOrigin;
    script.onload = () => {
      resolve();
      window.clearTimeout(timeoutId);
    };
    script.onerror = () => reject();
    document.body.appendChild(script);
    const timeoutId = window.setTimeout(reject, maxWait);
  });

export const createStylesheet = (url: string, srcIntegrity = '', crossOrigin = '', maxWait = 5000): Promise<void> =>
  new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${url}?t=${new Date().getTime()}`;
    link.integrity = srcIntegrity;
    link.crossOrigin = crossOrigin;
    link.onload = () => {
      resolve();
      window.clearTimeout(timeoutId);
    };
    link.onerror = () => reject();
    document.head.appendChild(link);
    const timeoutId = window.setTimeout(reject, maxWait);
  });

export const addGTMScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.textContent =
    '!function(e,t,a,n,g){e[n]=e[n]||[],e[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});var m=t.getElementsByTagName(a)[0],r=t.createElement(a);r.async=!0,r.src="https://www.googletagmanager.com/gtm.js?id=GTM-52NRT4HS",m.parentNode.insertBefore(r,m)}(window,document,"script","dataLayer")';
  document.body.appendChild(script);
};

/**
 * Observer to track all external scripts loaded in the DOM.
 */
export const externalScriptObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        const scriptNode = node as HTMLScriptElement;
        if (scriptNode.tagName === 'SCRIPT' && scriptNode.src) {
          scriptNode.onerror = () => {
            Track(OnePayEventNames.externalScriptFailed, { script: scriptNode.src, integrity: scriptNode.integrity });
          };
          Track(OnePayEventNames.externalScriptLoaded, { script: scriptNode.src, integrity: scriptNode.integrity });
        }
      });
    }
  }
});
